import { NotificationStatus } from './notification-status';

export class UpdateNotification {
  notificationIds: number[];
  notificationStatus: NotificationStatus;

  constructor(notificationIds, notificationStatus) {
    this.notificationIds = notificationIds;
    this.notificationStatus = notificationStatus;
  }
}
